import i18n from 'i18next';
import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

const fallbackLng = ['pt-BR'];
const availableLanguages = ['en', 'pt', 'pt-BR', 'it', 'es', 'es-AR'];

i18n
    .use(Backend) // load translation using xhr -> see /public/locales. We will add locales in the next step
    // .use(LanguageDetector) // detect user language
    .use(LanguageDetector) // detect user language
    .use(initReactI18next) // pass the i18n instance to react-i18next.
    .init({
        fallbackLng, // if user computer language is not on the list of available languages, than we will be using the fallback language specified earlier
        debug: false,
        whitelist: availableLanguages,
        ns: [
            'tranlation',
            'inventory',
            'load-unload',
            'expedition',
            'change-location',
            'login',
            'validations',
            'menu',
            'general',
            'physical-confirmation',
            'configuration',
            'areaType',
            'unitType',
            'modality',
            'plant',
            'area',
            'unit',
            'printer',
            'resource',
            'line-picking',
            'lowering',
            'shipment',
            'justification',
            'volume',
            'route-picking',
            'equipment',
            'qrcode-picking',
            'delivery',
            'route-delivery',
            'digital',
            'alternate-mdr',
            'unitWarehouse',
            'monitor',
            'unitOrdering',
            'movement-type',
            'truck-kanban',
            'partnumber-quantity',
            'stock',
            'deemsqp',
            'pab-replanning',
            'container',
            'issuer'
        ],
        allowMultiLoading: true,
        interpolation: {
            escapeValue: false
        },
        appendNamespaceToMissingKey: true,
        backend: {
            loadPath: '/locales/{{lng}}/{{ns}}.json',
        },
        react: {
            useSuspense: false //   <---- this will do the magic
        }
    });

export default i18n;